<template>
  <h3>{{ messages.tableHead[store.langSelect.value] }} </h3>
  
  <div class="mytable">
    <div v-show="history" class="table">
      <div class="thead">
        <div class="tr">
          <slot name="mtthead"></slot>

        </div>
      </div>
      <div class="tbody">
        <template v-for="(item, i) in store.FullHistory" :key="i">
          <slot v-bind:item="item" name="mttbody"></slot>
        <!--  <div class="tr"   >{{ item }}</div>-->

        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";
import { useMyStorage } from "@/store/global";

export default {
  name: "ServiceHistoryTable",
  props: ["service"],

  setup() {
    const store = useMyStorage();
    const accounts = store.GetAllAccountsToString();
    const history = reactive(store.FullHistory);
    console.log("history ---------------", store.FullHistory)

    /*   watch(positions_info, (nV) => {
         if (nV.value.length > 2) {
           posMin.value = false
         } else {
           posMin.value = true
         }

       })*/
    const getStringTime = (val) => {
      // console.log("++++++++++"+val+"----------")
      if (val < 2613553314) {
        let ts = new Date(val * 1000);
        return (
          pad(ts.getUTCDate()) +
          "/" +
          pad(ts.getUTCMonth() + 1) +
          "/" +
          ts.getUTCFullYear() +
          " " +
          pad(ts.getUTCHours()) +
          ":" +
          pad(ts.getUTCMinutes()) +
          ":" +
          pad(ts.getUTCSeconds())
        );
      }
      return "";
    };
    const pad = (n) => {
      return n < 10 ? "0" + n : n;
    };

    /*  getHistory()
    setInterval(()=>{
      getHistory()
    },30000)*/
    const messages = {
      tableHead: ["История заявок", "History of orders"],
    };
    return {
      messages,
      getStringTime,
      store,
      history,
      accounts,
    };
  },
};
</script>

<style>
.table {
  margin-top: 4px;
  width: 100%;
  display: table;
  table-layout: fixed;
  /*min-height: 80px;*/
}

.vmiddle {
  vertical-align: middle;
}

.thead {
  font-family: Proxima Nova Condensed;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 17px;
  color: #777777;
  width: 100%;
  padding-bottom: 4px;
  height: 17px;
  display: table-header-group;
}

.thead .tr .th {
  border-bottom: 1px solid #e82862;
  text-align: center;
}

.tr {
  display: table-row;
  width: 100%;
}

.cel,
.col,
.td,
.th {
  display: table-cell;
  width: 100%;
  padding: 2px 0px;
}

.tbody .tr .td {
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
}

.tbody {
  display: table-row-group;
}

.tbody .tr:nth-child(odd) {
  background-color: #f7f7f7;
}
</style>
